type Props = {
  clickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isOpen: boolean;
};

export default function SideMenuCollapseBtn({ clickHandler, isOpen }: Props) {
  return (
    <button
      onClick={clickHandler}
      className={`relative ml-auto mr-4 flex h-10 w-10 items-center justify-center rounded transition-all duration-300 hover:bg-white/5 hover:shadow-lg ${
        isOpen ? "" : "rotate-180"
      }`}
    >
      <img src="/icons/arrow-left.svg" alt="" />
    </button>
  );
}
